import { MaterialCommunityIcons } from '@expo/vector-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../themes/colors';
import { Button } from '../crop-circle/Button';
import { EmptyState } from '../feedback/EmptyState';

export interface OfflineUnavailableProps {
  /** Replaces the generic "Not available offline" title. */
  title?: string;
  message?: string;
  action?: { label: string; onPress: () => void };
}

export const OfflineUnavailable: React.FC<OfflineUnavailableProps> = ({
  title,
  message,
  action,
}) => {
  const { t } = useTranslation();
  return (
    <EmptyState
      testID="offline-unavailable"
      icon={
        <MaterialCommunityIcons
          name="wifi-off"
          size={32}
          color={Colors.role.textDisabled}
        />
      }
      title={title ?? t('offline.unavailable.title')}
      message={message}
      action={
        action ? (
          <Button
            size="default"
            onPress={action.onPress}
            testID="offline-unavailable-action"
          >
            {action.label}
          </Button>
        ) : undefined
      }
    />
  );
};
